<template>
  <div>
    <!-- <p>Ներկայիս Էջ: {{ props.page }}</p> -->
    <v-pagination
      class="flex-wrap justify-content-center"
      v-model="props.page"
      :page-count="props.totalPages"
      :classes="bootstrapPaginationClasses"
      @input="handlePageChange"
      :labels="paginationAnchorTexts"
    />
  </div>
</template>
<style scoped>
/* .pagination {
  white-space: nowrap;
}

#client-paginator {
  overflow-x: scroll;
  overflow-y: hidden;
  height: 200px;
  width: 100%;
  padding: 0 15px;
}

#client-paginator li {
  display: inline-block;  
} */
</style>
<script>
// :labels="paginationAnchorTexts"

import vPagination from 'vue-plain-pagination'
 
export default {
    name: "VtPagination",
    components: { vPagination },
    props: ['props'],
    methods: {
      handlePageChange(page) {
        if(page){
          this.props.setPage(page)
        }
      },
    },
    data() {
        return {
            name: "VtPagination",
            bootstrapPaginationClasses: {
              ul: 'pagination',
              li: 'page-item',
              liActive: 'active',
              liDisable: 'disabled',
              button: 'page-link'  
            },
            paginationAnchorTexts: {
              first: 'Առաջին',
              prev: 'Նախորդ',
              next: 'Հաջորդ',
              last: 'Վերջին',
            }
        }
    },
}
</script>